export default __webpack_public_path__ + "static/media/gallery-wip-handle_07.40ef0cca.jpg";